<template>
    <div class="userinfo">
        <el-form ref="userform" :model="userinfo" :rules="rules" label-width="80px" status-icon>
            <!-- <el-form-item label="原密码" prop="oldpassword">
                <el-input type="password" v-model="userinfo.oldpassword" placeholder="请输入原密码"></el-input>
            </el-form-item> -->
            <el-form-item label="新密码" prop="newpassword">
                <el-input type="password" v-model="userinfo.newpassword" placeholder="请输入新密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
                <el-input type="password" v-model="userinfo.checkPass" placeholder="请再次输入新密码"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="updatePassword('userform')">立即更新</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {updatePassword} from "@api/system";
/**
 * 用户信息部分
 * 修改用户密码
 */
export default {
    name:"userinfo",
    data(){
         var checkOldpassword = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('原密码不能为空'));
            }
            callback();
        };
        var validateNewpassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                // 检查长度
                var pattern = /^[\w_-]{6,16}$/;
                if(!pattern.test(value)){
                    callback(new Error('密码最短为6个字符'));
                }else{
                    // 触发验证
                    if (this.userinfo.checkPass !== '') {
                        this.$refs.userform.validateField('checkPass');
                    }
                    callback();
                }
            }
        };
        var validateNewpassword2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.userinfo.newpassword) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            userinfo:{
                username:"用户名", // 用户名
                oldpassword:"", // 原始密码
                newpassword:"", //新密码
                checkPass:"", //确认密码
            },
            rules: {
                newpassword: [
                    { validator: validateNewpassword, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validateNewpassword2, trigger: 'blur' }
                ],
                // oldpassword: [
                //     { validator: checkOldpassword, trigger: 'blur' }
                // ]
            }
        }
    },
    computed:{
        // 用户信息
        user(){
            return this.$store.getters.user;
        },
    },
    methods:{
        // 更新密码
        updatePassword(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    // 加密传输密码
                    let rsa_n = 'D42E861C04CFB9EBB1368A682EC22BDCA364A35E1C5DF1D43FC4F24197D4B798BCB7FD0192774749C4DED8B659002B4ABEA2F11F7896BCEE5CD615D31EF8936823ED6760CA01D91F677F1459019383679D78BE72FE67E7C1C3FDA1A514B5FE35879A9A9DC90EAE059948CD222F4C69F37F23F0864112CD4A8AE2B4FD9EC36297';
                    /* eslint-disable */
                    setMaxDigits(131); //131 => n的十六进制位数/2+3
                    let key  = new RSAKeyPair("10001", '', rsa_n); //10001 => e的十六进制

                    // 如果不是使用的临时密码登录的，则对密码进行加密
                    let oldpassword=this.userinfo.oldpassword;
                    // if(oldpassword.length<20){
                    //     oldpassword= encryptedString(key, oldpassword+'\x01'); //不支持汉字
                    // }
                    
                    let newpassword=encryptedString(key, this.userinfo.newpassword+'\x01'); //不支持汉字
                    // 更新密码
                    updatePassword(this.user.username,oldpassword,newpassword).then(res=>{
                        if(res.status==200){
                            this.$message({
                                message:"密码修改成功，请重新登录!",
                                type:"success",
                                duration:3000,
                                onClose:()=>{
                                    //清除sessionId
                                    sessionStorage.clear();
                                    this.$router.push("/login");
                                }
                            })
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
        }
    }
}
</script>

<style lang="scss">
.userinfo{
    width: 50%;
    text-align: center;
    left: 50%;
    position: relative;
    transform: translateX(-50%);
    padding: 20px;
}
</style>